import React, { useEffect, useState } from 'react';
import { useFilterContext } from "../../contexts/FilterContext";
import {useTranslation} from "react-i18next";
import CustomSelect from "../form/CustomSelect";

const SelectFilter = ({className, title , defaultValue,  closeDropdown, ...props}) => {

    const {name, filterValue, setFilterValue, updateURLParams } = useFilterContext();

    const handleChange = (e) => {
        setFilterValue(e.value);
    };

    useEffect(() => {
        if (filterValue) {
            updateURLParams(name, filterValue);
        } else if(defaultValue) {
            setFilterValue(defaultValue)
        }
    }, [filterValue]);

    return (
        <div className={`filter ${className}`}>
            <CustomSelect
                value={props.options.find(option => option.value === filterValue)}
                onChange={handleChange}
                {...props}
            />
        </div>
    );
};

export default SelectFilter;
